import * as app_jsx from './app.jsx'

export default [app_jsx]
